let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ec8N4")).then(() => parcelRequire('iotzD'));